module.exports = __webpack_public_path__ + "img/warning-all.2d9616a0.svg";